import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import {
  AuthContainer,
  AuthCard,
  AuthHeader,
  AuthTitle,
  AuthSubtitle,
  AuthForm,
  FormGroup,
  FormLabel,
  FormInput,
  AuthButton,
  ErrorMessage,
  AuthFooter,
  FooterText
} from './Auth.styles';

interface LoginProps {
  onToggleMode?: () => void;
}

const Login: React.FC<LoginProps> = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await signIn(username, password);
      // User will be redirected by the auth context
    } catch (err: any) {
      setError(err.message || 'Failed to sign in');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthContainer>
      <AuthCard>
        <AuthHeader>
          <AuthTitle>Sign In</AuthTitle>
          <AuthSubtitle>Access your Industrial ERP System</AuthSubtitle>
        </AuthHeader>
        
        <AuthForm onSubmit={handleSubmit}>
          {error && <ErrorMessage>{error}</ErrorMessage>}
          
          <FormGroup>
            <FormLabel htmlFor="username">Username or Email</FormLabel>
            <FormInput
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading}
              placeholder="Enter your username or email"
            />
          </FormGroup>

          <FormGroup>
            <FormLabel htmlFor="password">Password</FormLabel>
            <FormInput
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              placeholder="Enter your password"
            />
          </FormGroup>

          <AuthButton type="submit" disabled={loading} $loading={loading}>
            {loading ? 'Signing In...' : 'Sign In'}
          </AuthButton>
        </AuthForm>

        <AuthFooter>
          <FooterText>Contact your administrator to create an account</FooterText>
        </AuthFooter>
      </AuthCard>
    </AuthContainer>
  );
};

export default Login;